<div class="modal-header" id="add-participant-modal-title">
    <h3 class="modal-title" id="modal-title" translate="F4M_PARTICIPANTS_EDIT_PARTICIPANT_LABEL"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col">
            <form [formGroup]="participantForm">
                <fieldset>
                    <div class="row mb-3">
                        <span
                            class="col-sm-4 col-12 col-form-label text-start"
                            translate="F4M_PARTICIPANTS_TITLE_LABEL"
                        ></span>
                        <div class="col-sm-8 col-12 titles-dropdown">
                            <div class="input-group">
                                <div class="form-control flex-grow-1 dropdown-display" (click)="toggleTitlesDropdown()">
                                    {{ (participantTitles$ | async)[localParticipant.selectedTitle]?.displayValue }}
                                </div>
                                <span class="input-group-text" (click)="toggleTitlesDropdown()">
                                    <fa-icon [icon]="faCaretDown"></fa-icon>
                                </span>
                            </div>
                            @if (showTitlesDropdownMenu) {
                                <div class="background" (click)="toggleTitlesDropdown()"></div>
                            }
                            <ul class="dropdown-menu ms-3" role="menu" [ngClass]="{ show: showTitlesDropdownMenu }">
                                @for (
                                    participantTitle of participantTitles$ | async | keyvalue;
                                    track participantTitle
                                ) {
                                    <li role="menuitem">
                                        <a
                                            class="dropdown-item"
                                            (click)="onTitleSelected(participantTitle.value)"
                                            [ngClass]="{
                                                'highlight-selection':
                                                    participantTitle.value.value === localParticipant.selectedTitle,
                                            }"
                                        >
                                            {{ participantTitle.value.displayValue }}</a
                                        >
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-sm-4 col-8 text-start col-form-label"
                            translate="F4M_PARTICIPANTS_NON_CREDIT"
                            for="not-receiving-credit-checkbox"
                        ></label>
                        <div class="col-sm-8 col-4">
                            <div class="checkbox-container">
                                <input
                                    type="checkbox"
                                    [formControl]="notReceivingCredControl"
                                    class="form-control"
                                    id="not-receiving-credit-checkbox"
                                />
                                @if (localParticipant.notReceivingCredit) {
                                    <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                                }
                            </div>
                        </div>
                    </div>
                    @if (isOtherTitleSelected(localParticipant.selectedTitle)) {
                        <div class="row mb-3">
                            <label
                                class="col-sm-4 col-12 text-start col-form-label"
                                translate="F4M_PARTICIPANTS_TITLE_TEXT_LABEL"
                                for="other-title-text"
                            ></label>
                            <div class="col-sm-8 col-12">
                                <input
                                    type="text"
                                    class="form-control"
                                    [formControl]="titleControl"
                                    id="other-title-text"
                                />
                            </div>
                        </div>
                    }
                    <div class="row mb-3">
                        <label
                            class="col-sm-4 col-12 text-start col-form-label"
                            translate="F4M_PARTICIPANTS_FIRSTNAME_LABEL"
                            for="other-title-participant-firstname"
                        ></label>
                        <div class="col-sm-8 col-12">
                            <input
                                type="text"
                                class="form-control"
                                [formControl]="firstNameControl"
                                id="other-title-participant-firstname"
                            />
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-sm-4 col-12 text-start col-form-label"
                            translate="F4M_PARTICIPANTS_LASTNAME_LABEL"
                            for="other-title-participant-lastname"
                        ></label>
                        <div class="col-sm-8 col-12">
                            <input
                                type="text"
                                class="form-control"
                                [formControl]="lastNameControl"
                                id="other-title-participant-lastname"
                            />
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-sm-4 col-12 text-start col-form-label"
                            translate="F4M_PARTICIPANTS_EMAIL_LABEL"
                            for="other-title-participant-email"
                        ></label>
                        <div class="col-sm-8 col-12">
                            <input
                                type="text"
                                class="form-control"
                                [formControl]="mailControl"
                                id="other-title-participant-email"
                            />
                        </div>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary"
        [disabled]="participantForm.invalid"
        (click)="save()"
        translate="F4M_PARTICIPANTS_SAVE_PARTICIPANT_LABEL"
    ></button>
</div>
